// -----------------------------------------------------------
// FloraIQ — Aba Validação GIS
// -----------------------------------------------------------

import { gisInconsistencies } from "@/mocks/quality";
import { SeverityBadge } from "./QualityStatusBadge";

export default function GisValidationPanel() {
  const criticos = gisInconsistencies.filter((g) => g.severidade === "crítica").length;
  const altos = gisInconsistencies.filter((g) => g.severidade === "alta").length;
  const medios = gisInconsistencies.filter((g) => g.severidade === "média").length;

  return (
    <div className="space-y-6">
      {/* Cards resumo */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-white rounded-card border border-background-200/70 p-3">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 rounded-lg bg-green-100 flex items-center justify-center">
              <i className="ri-check-line text-green-600 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-foreground-600">Geometrias Válidas</span>
          </div>
          <p className="text-lg font-bold font-heading text-foreground-900">12.410</p>
        </div>
        <div className="bg-white rounded-card border border-background-200/70 p-3">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center">
              <i className="ri-pin-distance-line text-red-600 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-foreground-600">Coord. Fora do Município</span>
          </div>
          <p className="text-lg font-bold font-heading text-foreground-900">76</p>
        </div>
        <div className="bg-white rounded-card border border-background-200/70 p-3">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 rounded-lg bg-yellow-100 flex items-center justify-center">
              <i className="ri-stack-line text-yellow-600 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-foreground-600">Duplicidades Espaciais</span>
          </div>
          <p className="text-lg font-bold font-heading text-foreground-900">74</p>
        </div>
        <div className="bg-white rounded-card border border-background-200/70 p-3">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-7 h-7 rounded-lg bg-orange-100 flex items-center justify-center">
              <i className="ri-global-line text-orange-600 text-xs"></i>
            </div>
            <span className="text-xs font-medium text-foreground-600">SRID Pendente</span>
          </div>
          <p className="text-lg font-bold font-heading text-foreground-900">4</p>
        </div>
      </div>

      {/* Mapa mockado + problemas */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Mapa mockado */}
        <div className="lg:col-span-2 bg-slate-900 rounded-card p-4 border border-background-200/70 min-h-[320px] relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-slate-800 via-slate-900 to-slate-800"></div>
          {/* Grid de fundo */}
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)", backgroundSize: "40px 40px" }}></div>
          {/* Pontos mockados */}
          <div className="relative z-10 h-full flex flex-col">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs text-slate-400 font-mono">Mapa de Inconsistências GIS — Goiânia</span>
              <div className="flex items-center gap-3">
                <span className="flex items-center gap-1 text-xs text-slate-400"><span className="w-2 h-2 rounded-full bg-red-500"></span> Crítico</span>
                <span className="flex items-center gap-1 text-xs text-slate-400"><span className="w-2 h-2 rounded-full bg-orange-500"></span> Alta</span>
                <span className="flex items-center gap-1 text-xs text-slate-400"><span className="w-2 h-2 rounded-full bg-yellow-500"></span> Média</span>
              </div>
            </div>
            <div className="flex-1 relative">
              {/* Pontos aleatórios simulados */}
              <div className="absolute top-[15%] left-[20%] w-3 h-3 rounded-full bg-red-500 shadow-lg shadow-red-500/50 animate-pulse"></div>
              <div className="absolute top-[25%] left-[45%] w-3 h-3 rounded-full bg-red-500 shadow-lg shadow-red-500/50 animate-pulse"></div>
              <div className="absolute top-[40%] left-[60%] w-3 h-3 rounded-full bg-orange-500 shadow-lg shadow-orange-500/50"></div>
              <div className="absolute top-[55%] left-[30%] w-3 h-3 rounded-full bg-orange-500 shadow-lg shadow-orange-500/50"></div>
              <div className="absolute top-[20%] left-[75%] w-3 h-3 rounded-full bg-yellow-500 shadow-lg shadow-yellow-500/50"></div>
              <div className="absolute top-[60%] left-[70%] w-3 h-3 rounded-full bg-yellow-500 shadow-lg shadow-yellow-500/50"></div>
              <div className="absolute top-[70%] left-[15%] w-3 h-3 rounded-full bg-yellow-500 shadow-lg shadow-yellow-500/50"></div>
              <div className="absolute top-[35%] left-[85%] w-3 h-3 rounded-full bg-red-500 shadow-lg shadow-red-500/50 animate-pulse"></div>
              <div className="absolute top-[80%] left-[50%] w-3 h-3 rounded-full bg-orange-500 shadow-lg shadow-orange-500/50"></div>
              {/* Clusters */}
              <div className="absolute top-[10%] left-[50%] w-6 h-6 rounded-full border-2 border-yellow-400/60 bg-yellow-400/20 flex items-center justify-center">
                <span className="text-[8px] font-bold text-yellow-300">3</span>
              </div>
            </div>
          </div>
          <p className="relative z-10 text-xs text-slate-500 mt-2">Visualização simulada — preparada para integração com PostGIS / Leaflet / MapLibre</p>
        </div>

        {/* Lista de problemas */}
        <div className="bg-white rounded-card border border-background-200/70 p-4">
          <h4 className="text-sm font-semibold text-foreground-800 mb-3">Problemas Detectados</h4>
          <div className="space-y-2">
            {[
              { label: "Críticos (sem geometria / POINT EMPTY)", count: criticos, color: "red" },
              { label: "Altos (fora do município / sem SRID)", count: altos, color: "orange" },
              { label: "Médios (duplicidades / polígonos)", count: medios, color: "yellow" },
            ].map((item) => (
              <div key={item.color} className="flex items-center justify-between py-1.5">
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full bg-${item.color}-500`}></span>
                  <span className="text-xs text-foreground-600">{item.label}</span>
                </div>
                <span className="text-xs font-bold text-foreground-800">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Tabela GIS */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Unidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Tipo</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Geometria</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">SRID</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Problema</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Severidade</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Ações</th>
            </tr>
          </thead>
          <tbody>
            {gisInconsistencies.map((g) => (
              <tr key={g.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-mono text-foreground-700">{g.unidade}</td>
                <td className="px-3 py-2.5 text-foreground-600">{g.tipo}</td>
                <td className="px-3 py-2.5 text-foreground-500 font-mono max-w-[160px] truncate">{g.geometria}</td>
                <td className="px-3 py-2.5 text-foreground-600">{g.srid}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[200px] truncate">{g.problema}</td>
                <td className="px-3 py-2.5"><SeverityBadge severity={g.severidade} /></td>
                <td className="px-3 py-2.5 text-center">
                  <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Abrir no mapa">
                    <i className="ri-map-pin-line text-foreground-500 text-sm"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}